/**
 * Regeneration feature constants
 */

/** Available regeneration strategies in order */
export const REGENERATION_STRATEGIES = [
  "default",
  "detailed",
  "concise",
  "analogy",
  "creative",
] as const;

/** Maximum number of regeneration attempts allowed */
export const MAX_REGENERATION_ATTEMPTS = 3;

/** Type for regeneration strategy */
export type RegenerationStrategy = (typeof REGENERATION_STRATEGIES)[number];
